import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
const ObjectionService = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const {
    reset,
    handleSubmit,
    formState: { errors },
    register,
  } = useForm();

  const { loading, error, section } = useSelector((state) => state.section);

  const [sliders, setSliders] = useState([]);

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "howWeWorks",
        slug: "objectionService",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setSliders(section?.items);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.items = sliders;
    dispatch(
      editSection({
        slug: "objectionService",
        page: "howWeWorks",
        data: { section: data },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"objectionService"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id={"title"} /> ({" "}
                      <FormattedMessage id={"arabic-language"} /> )
                    </h5>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.secTitle ? "is-invalid" : ""
                      }`}
                      defaultValue={section?.secTitle?.ar || ""}
                      {...(errors.secTitle && { "aria-invalid": "true" })}
                      {...register("secTitle[ar]", { required: true })}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id={"title"} /> ({" "}
                      <FormattedMessage id={"english-language"} /> )
                    </h5>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.secTitle ? "is-invalid" : ""
                      }`}
                      defaultValue={section?.secTitle?.en || ""}
                      {...(errors.secTitle && { "aria-invalid": "true" })}
                      {...register("secTitle[en]", { required: true })}
                    />
                  </div>
                </Col>

                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id={"subTitle"} /> ({" "}
                      <FormattedMessage id={"arabic-language"} /> )
                    </h5>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.subTitle ? "is-invalid" : ""
                      }`}
                      defaultValue={section?.secSubTitle?.ar || ""}
                      {...(errors.secSubTitle && { "aria-invalid": "true" })}
                      {...register("secSubTitle[ar]", { required: true })}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id={"title"} /> ({" "}
                      <FormattedMessage id={"english-language"} /> )
                    </h5>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.subTitle ? "is-invalid" : ""
                      }`}
                      defaultValue={section?.secSubTitle?.en || ""}
                      {...(errors.secSubTitle && { "aria-invalid": "true" })}
                      {...register("secSubTitle[en]", { required: true })}
                    />
                  </div>
                </Col>

                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id={"description"} /> ({" "}
                      <FormattedMessage id={"arabic-language"} /> )
                    </h5>
                    <textarea
                      className={`form-control ${
                        errors.secDescription ? "is-invalid" : ""
                      }`}
                      defaultValue={section?.secDescription?.ar || ""}
                      {...(errors.secDescription && { "aria-invalid": "true" })}
                      {...register("secDescription[ar]", { required: true })}
                    ></textarea>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id={"description"} /> ({" "}
                      <FormattedMessage id={"english-language"} /> )
                    </h5>
                    <textarea
                      className={`form-control ${
                        errors.secDescription ? "is-invalid" : ""
                      }`}
                      defaultValue={section?.secDescription?.en || ""}
                      {...(errors.secDescription && { "aria-invalid": "true" })}
                      {...register("secDescription[en]", { required: true })}
                    ></textarea>
                  </div>
                </Col>
                <SlidersArray sliders={sliders} setSliders={setSliders} />
              </Row>

              <SaveChangesButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ObjectionService;
